document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-lightning-timer]').forEach(function (badge) {
    var endTime = new Date(badge.getAttribute('data-end-time')).getTime();
    var valueEl = badge.querySelector('[data-lightning-timer-value]');
    var card = badge.closest('.card-wrapper') || badge.closest('.card');

    if (isNaN(endTime) || !valueEl) return;

    function reveal() {
      badge.classList.add('hidden');
      if (card) {
        card.querySelectorAll('[data-lightning-fallback]').forEach(function (fallback) {
          fallback.classList.remove('hidden');
        });
      }
    }

    function update() {
      var diff = endTime - Date.now();

      if (diff <= 0) {
        reveal();
        clearInterval(intervalId);
        return;
      }

      var hours = Math.floor(diff / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      valueEl.textContent = hours + 'h ' + minutes + 'm ' + seconds + 's';
    }

    update();
    var intervalId = setInterval(update, 1000);
  });

  document.querySelectorAll('.card-product-usps').forEach(function (container) {
    const slider = container.querySelector('.usp-slider');
    const items = slider.querySelectorAll('.usp-pill');

    let index = 0;
    const itemHeight = 32;

    setInterval(function () {
      index++;

      slider.style.transition = 'transform 0.5s ease';
      slider.style.transform = `translateY(-${index * itemHeight}px)`;

      if (index === items.length - 1) {
        setTimeout(function () {
          slider.style.transition = 'none';
          slider.style.transform = 'translateY(0)';
          index = 0;
        }, 500);
      }
    }, 2500);
  });
});

// Auto-scrolls the card "target" value in an infinite loop, only when it is wider than its viewport.
// The "Target:" label sits outside the viewport and never moves.
if (!customElements.get('card-target-marquee')) {
  var MARQUEE_GAP = 32; // px between loop copies; keep in sync with .card-product-target__text--clone
  var MARQUEE_SPEED = 12; // px per second (lower = slower)

  customElements.define(
    'card-target-marquee',
    class CardTargetMarquee extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.card-product-target__viewport');
        this.text = this.querySelector('.card-product-target__text:not(.card-product-target__text--clone)');
        if (!this.viewport || !this.text) return;

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      update() {
        var textWidth = this.text.offsetWidth;
        var isOverflowing = textWidth > this.viewport.clientWidth + 1;

        this.classList.toggle('is-scrolling', isOverflowing);
        this.toggleClone(isOverflowing);
        if (!isOverflowing) return;

        var shift = textWidth + MARQUEE_GAP;
        this.style.setProperty('--marquee-shift', shift + 'px');
        this.style.setProperty('--marquee-duration', shift / MARQUEE_SPEED + 's');
      }

      toggleClone(show) {
        if (show && !this.clone) {
          this.clone = this.text.cloneNode(true);
          this.clone.classList.add('card-product-target__text--clone');
          this.clone.setAttribute('aria-hidden', 'true');
          this.viewport.appendChild(this.clone);
        } else if (!show && this.clone) {
          this.clone.remove();
          this.clone = null;
        }
      }
    }
  );
}
